import { ActionTree, ActionContext } from 'vuex'
import { AppState } from './state'

const actions: ActionTree<AppState, {}> = {
  setIsPageLoading: (
    context: ActionContext<AppState, {}>,
    isPageLoading: boolean
  ) => {
    context.commit('IS_PAGE_LOADING_UPDATED', isPageLoading)
  },
  setIsComponentLoading: (
    context: ActionContext<AppState, {}>,
    isComponentLoading: boolean
  ) => {
    context.commit('IS_COMPONENT_LOADING_UPDATED', isComponentLoading)
  },
  setError: (context: ActionContext<AppState, {}>, error: string) => {
    context.commit('APP_ERROR_UPDATED', error)
  },
  setNotification: (
    context: ActionContext<AppState, {}>,
    notification: string
  ) => {
    context.commit('APP_NOTIFICATION_UPDATED', notification)
  },
  setSuccess: (context: ActionContext<AppState, {}>, success: string) => {
    context.commit('APP_SUCCESS_UPDATED', success)
  },
  setIsAppLoading: (
    context: ActionContext<AppState, {}>,
    isAppLoading: boolean
  ) => {
    context.commit('IS_APP_LOADING_UPDATED', isAppLoading)
  },
}

export default actions
